export default "__VITE_ASSET__mUwdIFJV__"